import React from 'react'
import {
  checked
} from './Marketplace.module.scss'

import {
  FaRegStar,
  FaStarHalfAlt,
  FaStar
} from 'react-icons/fa'

export default function renderReviewStars (starCount) {
  const starHolder = []
  for (let i = 1; i <= 5; i++) {
    if (i <= starCount) {
      starHolder.push(<span key={i} className={checked}><FaStar /></span>)
    } else if (Math.ceil(starCount) === i) {
      starHolder.push(<span key={i} className={checked}><FaStarHalfAlt /></span>)
    } else {
      starHolder.push(<span key={i} className={checked}><FaRegStar /></span>)
    }
  }
  return starHolder
}
